import {
  useQuery,
  useMutation,
  useQueryClient
} from '@tanstack/react-query'

import { scenarioQueryKeys } from '../queryKeys'
import { singularResourcefulScenarioRequest } from '../requests'

export function useBudgetQuery({
  scenarioID,
  initialData,
  queryKey
}) {
  const queryClient = useQueryClient()
  const budgetRequests = singularResourcefulScenarioRequest(
    scenarioID, 'budget'
  )

  const budgetQuery = useQuery({
    queryFn: budgetRequests.show,
    queryKey,
    initialData
  })

  const updateBudgetMutation = useMutation({
    mutationFn: budgetRequests.update,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [scenarioQueryKeys(scenarioID).forecasts] })
      queryClient.invalidateQueries({ queryKey: [scenarioQueryKeys(scenarioID).budget] })
    },
  })

  const isFetching = budgetQuery.isFetching || updateBudgetMutation.isLoading

  const isAnyLoading = budgetQuery.isFetching ||
    updateBudgetMutation.isLoading

  return {
    data: budgetQuery.data,
    actions: {
      update: updateBudgetMutation.mutateAsync,
    },
    status: budgetQuery.status,

    /* Boolean flags indicating various states of status */
    isFetching: isFetching,
    isAnyLoading: isAnyLoading
  }
}
